window["CP_MS_PDP_06_V1"] = function () {
  if (
    document.querySelector(".CP_MS_PDP_06_V1") &&
    !document.body.classList.contains("CP_MS_PDP_06_V1")
  ) {
    document.body.classList.add("CP_MS_PDP_06_V1");

    const container = document.querySelector(".CP-carousel-container");
    const track = container.querySelector(".CP-carousel-track");
    const dotsContainer = container.querySelector(".CP-carousel-dots");

    const playIconSVG = `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="#e3e3e3"><path d="m380-300 280-180-280-180v360Z"></path></svg>`;
    const pauseIconSVG = `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="#e3e3e3"><path d="M360-320h80v-320h-80v320Zm160 0h80v-320h-80v320Z"></path></svg>`;

    // Clone first/last for infinite loop
    const slidesInit = track.querySelectorAll(".CP-carousel-card");
    const firstClone = slidesInit[0].cloneNode(true);
    const lastClone = slidesInit[slidesInit.length - 1].cloneNode(true);
    track.appendChild(firstClone);
    track.insertBefore(lastClone, slidesInit[0]);

    let currentIndex = 1;
    let isVisible = false;
    let isAnimating = false;

    function pauseAllVideos() {
      track.querySelectorAll("video").forEach((video) => {
        video.pause();
        const btn = video.parentElement.querySelector(".CP-play-btn");
        if (btn && btn.innerHTML !== playIconSVG) {
          btn.innerHTML = playIconSVG;
        }
      });
    }

    // Force load a single video → apply src + load first frame
    function forceLoadVideo(video) {
      if (video && video.dataset.src && !video.src) {
        video.src = video.dataset.src;
        video.load(); // ensures first frame shows
      }
    }

    // Lazy load videos
    function lazyLoadVideos() {
      const videoWrappers = track.querySelectorAll("video[data-src]");
      const videoObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              forceLoadVideo(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { root: null, threshold: 0.5 }
      );
      videoWrappers.forEach((video) => videoObserver.observe(video));
    }

    function updateCarousel(smooth = true) {
      const cards = track.querySelectorAll(".CP-carousel-card");
      const totalCards = cards.length;

      const cardWidth = cards[0].offsetWidth + 8;
      const containerWidth = container.offsetWidth;
      const offset = (containerWidth - cardWidth) / 2;
      const translateX = -currentIndex * cardWidth + offset;

      track.style.transition = smooth ? "transform 0.4s ease" : "none";
      track.style.transform = `translateX(${translateX}px)`;

      cards.forEach((card, index) => {
        const video = card.querySelector("video");
        const btn = card.querySelector(".CP-play-btn");

        if (index === currentIndex) {
          // Active card — don't reset button
          card.classList.add("is-active");
        } else {
          card.classList.remove("is-active");

          // Only reset if video was actually playing
          if (video && !video.paused) {
            video.pause();
            if (btn && btn.innerHTML !== playIconSVG) {
              btn.innerHTML = playIconSVG;
            }
          }
        }
      });

      // ✅ Preload active + neighbors
      const activeCard = cards[currentIndex];
      const prevCard = cards[currentIndex - 1];
      const nextCard = cards[currentIndex + 1];

      if (activeCard) forceLoadVideo(activeCard.querySelector("video"));
      if (prevCard) forceLoadVideo(prevCard.querySelector("video"));
      if (nextCard) forceLoadVideo(nextCard.querySelector("video"));

      const realIndex =
        currentIndex === 0
          ? totalCards - 2
          : currentIndex === totalCards - 1
          ? 1
          : currentIndex;

      dotsContainer.querySelectorAll(".CP-dot").forEach((dot, i) => {
        dot.classList.toggle("active", i + 1 === realIndex);
      });
    }

    track.addEventListener("transitionend", () => {
      const cards = track.querySelectorAll(".CP-carousel-card");
      const totalCards = cards.length;

      if (currentIndex === 0) {
        currentIndex = totalCards - 2;
        updateCarousel(false);
      } else if (currentIndex === totalCards - 1) {
        currentIndex = 1;
        updateCarousel(false);
      }

      isAnimating = false;
    });

    function moveSlide(step) {
      if (isAnimating) return;
      isAnimating = true;
      currentIndex += step;
      updateCarousel(true);
    }

    // Swipe
    let startX = 0;
    track.addEventListener("touchstart", (e) => (startX = e.touches[0].clientX));
    track.addEventListener("touchend", (e) => {
      const endX = e.changedTouches[0].clientX;
      if (endX - startX > 50) moveSlide(-1);
      else if (startX - endX > 50) moveSlide(1);
    });

    // Dot nav
    dotsContainer.addEventListener("click", (e) => {
      if (e.target.classList.contains("CP-dot")) {
        const targetIndex = Number(e.target.dataset.index);
        if (isAnimating) return;
        currentIndex = targetIndex;
        updateCarousel(true);
      }
    });

    // Arrows
    const prevBtn = container.querySelector(".CP-prev");
    const nextBtn = container.querySelector(".CP-next");
    if (prevBtn && nextBtn) {
      prevBtn.addEventListener("click", () => moveSlide(-1));
      nextBtn.addEventListener("click", () => moveSlide(1));
    }

    // Pause when hidden
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          isVisible = entry.isIntersecting && entry.intersectionRatio >= 0.7;
          if (!isVisible) pauseAllVideos();
          updateCarousel(false);
        });
      },
      { threshold: 0.7 }
    );
    observer.observe(container);

    // Play button toggle
    track.addEventListener("click", (e) => {
      const btn = e.target.closest(".CP-play-btn");
      if (!btn) return;
      const wrapper = btn.closest(".CP-video-wrapper");
      const video = wrapper.querySelector("video");
      if (!video) return;

      if (video.paused) {
        pauseAllVideos();
        video.play().then(() => (btn.innerHTML = pauseIconSVG));
      } else {
        video.pause();
        btn.innerHTML = playIconSVG;
      }
    });

    lazyLoadVideos();
    updateCarousel(false);
  } else if (!document.body.classList.contains("CP_MS_PDP_06_V1")) {
    window.requestAnimationFrame(window.CP_MS_PDP_06_V1);
  }
};

window.CP_MS_PDP_06_V1();
